import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

/**
 * ModeratorNotesAccordion Component
 * Displays moderator notes in an expandable accordion (similar to OwnerReviewForRenter)
 */
const ModeratorNotesAccordion = ({ moderatorNotes }) => {
  const { t } = useTranslation('dashboard');

  if (!moderatorNotes) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Accordion
        defaultExpanded={false}
        sx={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffc107',
          '&:before': {
            display: 'none',
          },
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            '& .MuiAccordionSummary-content': {
              alignItems: 'center',
              gap: 1,
            },
          }}
        >
          <WarningAmberIcon sx={{ color: '#ff9800', fontSize: 28 }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#856404' }}>
              {t('myReservations.reviews.changeRequested.title', 'Modifications demandées par notre équipe')}
            </Typography>            
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              backgroundColor: '#ffffff',
              border: '1px solid #ffc107',
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" sx={{ color: '#856404', mt: 0.5 }}>
              {t('myReservations.reviews.changeRequested.message', 'Merci de mettre à jour votre avis afin qu\'il respecte nos lignes éditoriales.')}
            </Typography>
            <Divider sx={{ my: 1, borderColor: '#ffc107' }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'error.main' }}>
              {t('myReservations.reviews.changeRequested.modal.notesTitle', 'Notes du modérateur :')}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#333',
                whiteSpace: 'pre-wrap',
                lineHeight: 1.6,
              }}
            >
              {moderatorNotes}
            </Typography>
          </Paper>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

ModeratorNotesAccordion.propTypes = {
  moderatorNotes: PropTypes.string,
};

ModeratorNotesAccordion.defaultProps = {
  moderatorNotes: null,
};

export default ModeratorNotesAccordion;
